import Vue, { Component } from 'vue';
import { Playground as ConditionReportPlayground } from '../../apps/condition-report'
import { Playground as TrackingPlayground } from '../../apps/tracking'

export interface AppConfig {
    id: string,
    nameI18NKey: string,
    rootComponent: Component,
    defaultRouteName: string,
}

export const appsConfig = {
    // Put this key in a deployment configuration to add this app to the launcher
    conditionReport: {
        defaultRouteName: "conditionReportHome",
        id: "condition-report",
        nameI18NKey: "conditionReportAppTitle",
        rootComponent: ConditionReportPlayground,
    } as AppConfig,
    tracking: {
        defaultRouteName: "trackingHome",
        id: "tracking",
        nameI18NKey: "trackingAppTitle",
        rootComponent: TrackingPlayground,
    } as AppConfig,

    // tslint:disable-next-line:object-literal-sort-keys
    audit: {
        defaultRouteName: "",
        id: "audit",
        nameI18NKey: "Récolement",
        rootComponent: Vue.component('hello-world', {
            template: "<h1>Récolement coming soon...</h1>"
        }),
    },
    // Future app not developped yet...
    reporting: {
        defaultRouteName: "",
        id: "reporting",
        nameI18NKey: "Reportage",
        rootComponent: Vue.component('hello-world', {
            template: "<h1>Reportage coming soon...</h1>"
        }),
    }
}